// Open a PDF from the API in a new tab and print it (the desktop Sales Order page's labels,
// manifests and slips). Moved from SOPackagingPlanCard; features/desktopUi.js hands it to the shared
// pallet actions as ui.openPdfTab. A phone has none: it can't open a tab after an await (iOS blocks
// the pop-up), so its screens offer the PDF from a tap instead.
import { detailToString } from '../../utils/apiError';

export async function openPdfTab(url, fallbackName) {
  const res = await fetch(url);
  if (!res.ok) {
    const b = await res.json().catch(() => ({}));
    throw new Error(detailToString(b.detail) || `HTTP ${res.status}`);
  }
  const blob = await res.blob();
  const blobUrl = URL.createObjectURL(blob);
  const w = window.open(blobUrl, '_blank');
  if (w) {
    w.addEventListener('load', () => { try { w.focus(); w.print(); } catch (_) { /* noop */ } });
  } else {
    const a = document.createElement('a');
    a.href = blobUrl; a.download = fallbackName;
    document.body.appendChild(a); a.click(); document.body.removeChild(a);
  }
  setTimeout(() => URL.revokeObjectURL(blobUrl), 20000);
}
